import styled from '@emotion/styled'
import { Primary } from '@sphinx/components-styles'

export const LoaderWrap = styled('div')`
  display: flex;
  height: calc(100% - 32px);
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${Primary.navy['80']};
`
